var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._b({key:_vm.reloadKey,attrs:{"src":_vm.displaySrc},on:{"error":_vm.onError}},'el-image',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }